import React, { Fragment } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { SITENAMEALIAS } from '../utils/init';
import { Link,withRouter } from 'react-router-dom';
import btcLogo from '../assets/images/currency/BTC.svg'


class Balances extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            pageNo: 1,
            noOfItemsPerPage: 20,
        };

    }


    render() {
        return (
            <Fragment>
               <div className="container">
  <div className="row">
    <div className="col-lg-12">
      <h1>Terms of Use</h1>
      <p>
        This is a binding Agreement between {localStorage.getItem(SITENAMEALIAS + "_companyName") }
        (“{localStorage.getItem(SITENAMEALIAS + "_exchange") }” or“Company” or “We”) and the person, persons, or entity
        (“You” or “Your”) using the service, Software, or application
        (“Software”).
      </p>
      <h3>Rights and Obligations</h3>
      <p>
      {localStorage.getItem(SITENAMEALIAS + "_exchange") } provides the Software solely on the terms and conditions
        set forth in this Agreement and on the condition that You accept and
        comply with them. By using the Software You
      </p>
      <ol className="privacy-terms-content" type="a">
        <li>
          accept this Agreement and agree that You are legally bound by its
          terms; and
        </li>
        <li>
          represent and warrant that:
          <ol className="privacy-terms-content" type="i">
            <li>You are of legal age to enter into a binding agreement; and</li>
            <li>
              if You are a corporation, governmental organization or other legal
              entity, You have the right, power and authority to enter into this
              Agreement on behalf of the corporation, governmental organization
              or other legal entity and bind them to these terms.
            </li>
          </ol>
        </li>
      </ol>
      <p>
        This Software functions as a free, open source, and multi-signature
        digital wallet. The Software does not constitute an account where We or
        other third parties serve as financial intermediaries or custodians of
        Your bitcoin(s).
      </p>
      <p>
        While the Software has undergone beta testing and continues to be
        improved by feedback from the open-source user and developer community,
        We cannot guarantee there will not be bugs in the Software. You
        acknowledge that Your use of this Software is at Your own discretion and
        in compliance with all applicable laws. You are responsible for
        safekeeping Your passwords, private key pairs, PINs, and any other codes
        You use to access the Software.
      </p>
      <p>
        IF YOU LOSE ACCESS TO YOUR BITCOIN WALLET OR YOUR ENCRYPTED PRIVATE KEYS
        AND YOU HAVE NOT SEPARATELY STORED A BACKUP OF YOUR WALLET AND
        CORRESPONDING PASSWORD, YOU ACKNOWLEDGE AND AGREE THAT ANY BITCOIN YOU
        HAVE ASSOCIATED WITH THAT WALLET WILL BECOME INACCESSIBLE. All
        transaction requests are irreversible. The authors of the Software,
        employees and affiliates of {localStorage.getItem(SITENAMEALIAS + "_exchange") }, copyright holders cannot
        retrieve Your private keys or passwords if You lose or forget them and
        cannot guarantee transaction confirmation as they do not have control
        over the bitcoin network.
      </p>
      <h3>Disclaimer</h3>
      <p>
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON INFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OF THE SOFTWARE, EMPLOYEES AND AFFILIATES
        OF {localStorage.getItem(SITENAMEALIAS + "_exchange") }, COPYRIGHT HOLDERS, OR {localStorage.getItem(SITENAMEALIAS + "_exchange") }. BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      </p>
      <p>
        IN NO EVENT WILL {localStorage.getItem(SITENAMEALIAS + "_exchange") } OR ITS AFFILIATES, OR ANY OF ITS OR THEIR
        RESPECTIVE SERVICE PROVIDERS, BE LIABLE TO YOU OR ANY THIRD PARTY FOR
        ANY USE, INTERRUPTION, DELAY OR INABILITY TO USE THE SOFTWARE, LOST
        REVENUES OR PROFITS, DELAYS, INTERRUPTION OR LOSS OF SERVICES, BUSINESS
        OR GOODWILL, LOSS OR CORRUPTION OF DATA, LOSS RESULTING FROM SYSTEM OR
        SYSTEM SERVICE FAILURE, MALFUNCTION OR SHUTDOWN, FAILURE TO ACCURATELY
        TRANSFER, READ OR TRANSMIT INFORMATION, FAILURE TO UPDATE OR PROVIDE
        CORRECT INFORMATION, SYSTEM INCOMPATIBILITY OR PROVISION OF INCORRECT
        COMPATIBILITY INFORMATION OR BREACHES IN SYSTEM SECURITY, OR FOR ANY
        CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL OR PUNITIVE
        DAMAGES, WHETHER ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT,
        BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE, REGARDLESS
        OF WHETHER SUCH DAMAGES WERE FORESEEABLE AND WHETHER OR NOT WE WERE
        ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      </p>
      <h3>Intellectual Property</h3>
      <p>
        We retain all right, title, and interest in and to the Content and all
        of {localStorage.getItem(SITENAMEALIAS + "_exchange") }’s brands, logos, and trademarks, including, but not
        limited to {localStorage.getItem(SITENAMEALIAS + "_exchange") }, {localStorage.getItem(SITENAMEALIAS + "_exchange") } – Secure Bitcoin Wallet,
        {localStorage.getItem(SITENAMEALIAS + "_exchange") } Wallet,&nbsp;
        <a
          href={localStorage.getItem(SITENAMEALIAS + "_exchange") }
          target="_blank"
          rel="noopener"
        >
          {localStorage.getItem(SITENAMEALIAS + "_exchange") } App
        </a>
        &nbsp;and variations of the wording of the aforementioned brands, logos,
        and trademarks.
      </p>
      <h3>Severability</h3>
      <p>
        In the event any court shall declare any section or sections of this
        Agreement invalid or void, such declaration shall not invalidate the
        entire Agreement and all other paragraphs of the Agreement shall remain
        in full force and effect.
      </p>
      <h3>Binding Agreement</h3>
      <p>
        The terms and provisions of this Agreement are binding upon Your heirs,
        successors, assigns, and other representatives. This Agreement may be
        executed in counterparts, each of which shall be considered to be an
        original, but both of which constitute the same Agreement.
      </p>
      <p>
        You assume any and all risks associated with the use of the Software. We
        reserve the right to modify this Agreement from time to time.
      </p>
    </div>
  </div>
</div>
            </Fragment>

        )
    }

    componentDidMount() {


    }

}



export default withRouter(Balances);

